import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  error: string | null;
}

const initialState: AuthState = {
  error: null,
};

const apiErrorSlice = createSlice({
  name: 'apiError',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setError, clearError } = apiErrorSlice.actions;
export default apiErrorSlice.reducer;